import GOTUtil from '../utils/GOTUtil';
import GOT from '../utils/GOT';
import FormItemUtil from '../utils/FormItemUtil';
import StringUtil from '../utils/StringUtil';
export default class FormDataSource
{
	
    constructor(xml,menuItemId,formId,forLookup)
    {
    	this.xml = xml;
        this.id = xml.id;
        var tablePro = this.xml.Properties.Table;
        if(!tablePro.hasOwnProperty("refentityid"))
                throw new Error("GOT错误，id为"+this.xml.id+"的FormDataSource没有关联Table");
        this.tableId = tablePro.refentityid;
        this.tableName = tablePro.Value;
        this.isAggreateTable = false;
        this.isPivotTable = false;
        this.alias = this.xml.name;
        this.sourceName = this.xml.name;
        this.joinType = GOTUtil.getPropertyValue(xml, "JoinType");

        var _table = GOT.getTable(this.tableId);
        
        this.isTempTable = GOTUtil.getPropertyValue(_table,"Temporary")=="true";        
       
        this.idGenerator = "Identity";
        
        this.tableGroup = GOTUtil.getPropertyValue(_table,"TableType");
       
        var _fetchAll = GOTUtil.getPropertyValue(xml, "FetchAll") == "true";
        if(_fetchAll || this.isTempTable)
            this.fetchAll = true;
        else
            this.fetchAll = false;
        if(this.isTempTable == false)
        {
            var _key = FormItemUtil.getFormStoresKey(menuItemId,formId);
            var formStore = window.parent.window[_key];
            //formStore只针对于正常FormModule有用 针对于FormLookup及查询器、万能视图上的FormLookup等无用
            if(formStore)
            {
                var tmpAlias = formStore.listTmpTable;
                if(tmpAlias && tmpAlias.indexOf(this.alias)>-1)
                {
                    this.isTempTable = true;
                }
                else
                {
                    var listAggreate = formStore.listAggregateTable;
                    if(listAggreate && listAggreate.indexOf(this.alias)>-1)
                    {
                        this.isAggreateTable = true;
                        this.xml.Properties.AllowAttachment.Value = false;
                    }

                    var listPivotTable = formStore.listPivotTable;
                    if(listPivotTable && listPivotTable.indexOf(this.alias)>-1)
                    {
                        this.isPivotTable = true;
                    }
                }
            }
            
        }

        if(this.isTempTable == true)
        {
            this.xml.Properties.AllowAttachment.Value = false;
        }

		this.joinType = GOTUtil.getPropertyValue(this.xml,"JoinType");
		this.startPosition = GOTUtil.getPropertyValue(this.xml,"StartPosition");
        this.allowExternalJoin = GOTUtil.getPropertyValue(this.xml,"ExternalJoin");
        this.fieldNumOfDecimals = {};//用于在获取记录以后 根据numOfDecimals去处理所有的记录的所有Decimals字段的值补零
        this.fieldType = this.initFieldType(_table);
	}

    addExtralFieldType(field,type)
    {
        if(!this.fieldType)
            this.fieldType = {};
        this.fieldType[field] = type;    
    }

    initFieldType(_table)
    {
        let fieldType = {};
        
        let list = this.xml.FormDataSourceFields;
        if(!list || list.length==0)
        {
            list = _table.TableFields;
        }

        for(let i in list)
        {
            let field = list[i];
            let fieldName = StringUtil.convertToEachFirstLowerCase(field.name);
            fieldType[fieldName] = field.type;
            if(field.type == "Decimal")
            {
                this.fieldNumOfDecimals[fieldName] = 
                     GOTUtil.getPropertyValueStepByStep(field,null,"NumOfDecimals", "", false, false);
            }
        }
        return fieldType;
    }	
    
}
  


// WEBPACK FOOTER //
// ./src/datasource/FormDataSource.js